import { z } from "zod";
/**
 * One thing a 4xx refused (ADR-033 rule 7, amended 2026-10-26): what, as a
 * stable code and a message for people, and a path to the field to blame,
 * where one is. What the path names is the endpoint's to say: a form's is an
 * answer key.
 */
export const ProblemSchema = z.object({
    code: z.string(),
    message: z.string(),
    field: z.string().optional(),
});
export const ApiErrorSchema = z.object({
    statusCode: z.number(),
    error: z.string(),
    message: z.string(),
    /**
     * A stable identifier for the rejection, set on any 4xx a client branches on
     * (ADR-033 rule 7). `message` is written for people and may be reworded; this
     * is the part a client may depend on.
     */
    code: z.string().optional(),
    /**
     * Everything a 4xx refused, when it refused more than one thing or particular
     * fields; `message` is the first's. Absent otherwise.
     */
    problems: ProblemSchema.array().optional(),
});
